import React, { useEffect, useState } from 'react'
import { Blacked, DBModalContent, DBModalInput, DBModalInputLine, DBModalInputWrap, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, Select, message } from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { useStatusList } from 'CRM/hooks/GetStatusList';
import { usePlatformList } from 'CRM/hooks/GetPlatformList';
import { useBranchList } from 'CRM/hooks/GetBranchList';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs'
import 'dayjs/locale/ko';
import { useDBList } from 'CRM/hooks/GetDBTable';
import { useMyInfo } from 'CRM/hooks/GetMyInfo';
import {useIsMobile} from "../IsMobile";

dayjs.locale('ko');

export const DBInput = ({ setIsDBInput, pathList, resList }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { mutate } = useDBList('','','','','','','','','')
  const { statusList } = useStatusList();
  const { platformList } = usePlatformList();
  const { branchList } = useBranchList();
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [gender, setGender] = useState('m');
  const [branch, setBranch] = useState(branchList?.[0]?.id);
  const [respon, setRespon] = useState(resList?.[0]?.id);
  const [status, setStatus] = useState('0');
  const [experience, setExperience] = useState('false');
  const [inquiry, setInquiry] = useState('');
  const [memo, setMemo] = useState('');
  const [time, setTime] = useState('');
  const [path, setPath] = useState(pathList?.[0]?.id);
  const [platform, setPlatform] = useState(platformList?.[0]?.id);

  const [currentTime, setCurrentTime] = useState(dayjs());
  const { myInfo } = useMyInfo();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const addUser = () => {
    const shouldEdit = window.confirm(`DB를 생성하시겠습니까?`);
    if(shouldEdit) {
      if(name == '') {
        message.error('이름은 필수 입력입니다.')
      } else {
        API.post('/users', token + '', {
          name: name,
          tel: tel,
          gender: gender,
          branchId: 0,
          responsibilityId: resList?.find(it => it.name == myInfo?.name)?.id || 0,
          statusId: status,
          experience: experience,
          inquiry: inquiry,
          counselingMemo: memo,
          counselingTime: time,
          accessPathId: path,
          platformId: platform,
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('등록되었습니다');
            mutate();
            setIsDBInput(false);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsDBInput(false)} />
      {IsMobile ?
        <ModalWrapper IsMobile={IsMobile}>
          <ModalHeader>
            <Icon onClick={() => setIsDBInput(false)}><FaChevronLeft /></Icon>
            <ModalTitle>DB 직접 입력</ModalTitle>
            <ModalSubmit onClick={addUser}>저장</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label>이름 *</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label>연락처</label>
                <DBModalInputWrap>
                  <Input type="text" value={tel} onChange={(e) => setTel(e.target.value)} placeholder='연락처를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label>성별</label>
                <DBModalInputWrap>
                  <Select value={gender} onChange={(e) => setGender(e)}>
                    <option style={{fontFamily: 'Pretendard'}} value='m'>남성</option>
                    <option style={{fontFamily: 'Pretendard'}} value='f'>여성</option>
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>




            <DBModalInputLine>
              <DBModalInput>
                <label>플랫폼</label>
                <DBModalInputWrap>
                  <Select value={platform} onChange={(e) => setPlatform(e)}>
                    {platformList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label>방문경로</label>
                <DBModalInputWrap>
                  <Select value={path} onChange={(e) => setPath(e)}>
                    {pathList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>




            <DBModalInputLine>
              <DBModalInput>
                <label>담당자</label>
                <DBModalInputWrap>
                  {resList?.find(it => it.name == myInfo?.name)?.name}
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>


            <DBModalInputLine>
              <DBModalInput>
                <label>상태</label>
                <DBModalInputWrap>
                  <Select value={status == '0' ? '대기' : status} onChange={(e) => setStatus(e)}>
                    <option value={'0'}>대기</option>
                    {statusList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>


            <DBModalInputLine>
              <DBModalInput>
                <label>이용경험</label>
                <DBModalInputWrap>
                  <Select value={experience} onChange={(e) => setExperience(e)}>
                    <option style={{fontFamily: 'Pretendard'}} value='false'>무</option>
                    <option style={{fontFamily: 'Pretendard'}} value='true'>유</option>
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>


            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: '60px 0'}}>문의사항</label>
                <DBModalInputWrap>
                  <TextArea
                    onChange={(e) => setInquiry(e.target.value)}
                    placeholder="문의사항 입력"
                    value={inquiry}
                    style={{ width: '100%', height: 120, resize: 'none' }}
                  />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>


            <DBModalInputLine>
              <DBModalInput style={{borderBottom: '1px solid #d8d8d8'}}>
                <label style={{padding: '60px 0'}}>원하는상담내용</label>
                <DBModalInputWrap>
                  <TextArea
                    onChange={(e) => setMemo(e.target.value)}
                    placeholder="상담내용 입력"
                    value={memo}
                    style={{ width: '100%', height: 120, resize: 'none' }}
                  />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>



            <DBModalInputLine>
              <DBModalInput style={{borderBottom: '1px solid #d8d8d8'}}>
                <label>원하는상담시간</label>
                <DBModalInputWrap>
                  <Input type="text" value={time} onChange={(e) => setTime(e.target.value)} placeholder='상담시간을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput style={{borderRight: '1px solid #d8d8d8', borderTop: 'none'}}>
                <DBModalInputWrap style={{padding: 10, textAlign: 'right'}}>
                  {currentTime.format('YYYY-MM-DD(dd) HH:mm:ss')}
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

          </DBModalContent>
        </ModalWrapper>
        :
        <ModalWrapper style={{width: 1200}}>
          <ModalHeader>
            <Icon onClick={() => setIsDBInput(false)}><FaChevronLeft /></Icon>
            <ModalTitle>DB 직접 입력</ModalTitle>
            <ModalSubmit onClick={addUser}>저장</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label>이름 *</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label>연락처</label>
                <DBModalInputWrap>
                  <Input type="text" value={tel} onChange={(e) => setTel(e.target.value)} placeholder='연락처를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label>성별</label>
                <DBModalInputWrap>
                  <Select value={gender} onChange={(e) => setGender(e)}>
                    <option style={{fontFamily: 'Pretendard'}} value='m'>남성</option>
                    <option style={{fontFamily: 'Pretendard'}} value='f'>여성</option>
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label>플랫폼</label>
                <DBModalInputWrap>
                  <Select value={platform} onChange={(e) => setPlatform(e)}>
                    {platformList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
              {/* <DBModalInput>
              <label>지점</label>
              <DBModalInputWrap>
                <Select value={branch} onChange={(e) => setBranch(e)}>
                  {branchList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                  ))}
                </Select>
              </DBModalInputWrap>
            </DBModalInput> */}
              <DBModalInput>
                <label>방문경로</label>
                <DBModalInputWrap>
                  <Select value={path} onChange={(e) => setPath(e)}>
                    {pathList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label>담당자</label>
                <DBModalInputWrap>
                  {resList?.find(it => it.name == myInfo?.name)?.name}
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label>상태</label>
                <DBModalInputWrap>
                  <Select value={status == '0' ? '대기' : status} onChange={(e) => setStatus(e)}>
                    <option value={'0'}>대기</option>
                    {statusList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label>이용경험</label>
                <DBModalInputWrap>
                  <Select value={experience} onChange={(e) => setExperience(e)}>
                    <option style={{fontFamily: 'Pretendard'}} value='false'>무</option>
                    <option style={{fontFamily: 'Pretendard'}} value='true'>유</option>
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: '60px 0'}}>문의사항</label>
                <DBModalInputWrap>
                  <TextArea
                    onChange={(e) => setInquiry(e.target.value)}
                    placeholder="문의사항 입력"
                    value={inquiry}
                    style={{ width: '100%', height: 120, resize: 'none' }}
                  />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput style={{borderBottom: '1px solid #d8d8d8'}}>
                <label style={{padding: '60px 0'}}>원하는상담내용</label>
                <DBModalInputWrap>
                  <TextArea
                    onChange={(e) => setMemo(e.target.value)}
                    placeholder="상담내용 입력"
                    value={memo}
                    style={{ width: '100%', height: 120, resize: 'none' }}
                  />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput style={{width: '50%', borderTop: 'none'}}>
                <label>원하는상담시간</label>
                <DBModalInputWrap>
                  <Input type="text" value={time} onChange={(e) => setTime(e.target.value)} placeholder='상담시간을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput style={{width: '50%', borderRight: '1px solid #d8d8d8', borderTop: 'none'}}>
                <DBModalInputWrap style={{padding: 10, textAlign: 'right'}}>
                  {currentTime.format('YYYY-MM-DD(dd) HH:mm:ss')}
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
          </DBModalContent>
        </ModalWrapper>
      }
    </>
  )
}

export default React.memo(DBInput);